import { render, staticRenderFns } from "./ThemeSettings.vue?vue&type=template&id=e52488b8&scoped=true"
import script from "./ThemeSettings.vue?vue&type=script&lang=js"
export * from "./ThemeSettings.vue?vue&type=script&lang=js"
import style0 from "./ThemeSettings.vue?vue&type=style&index=0&id=e52488b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52488b8",
  null
  
)

export default component.exports